import { BoardColumnColorType } from '../types';

export const BOARD_COLUMN_COLORS_MAP: Record<BoardColumnColorType, string> = {
  green: 'board-column__header--top-line-green',
  primary: 'board-column__header--top-line-primary',
  orange: 'board-column__header--top-line-orange',
  red: 'board-column__header--top-line-red',
  gray: 'board-column__header--top-line-gray',
  purple: 'board-column__header--top-line-purple',
};
